import {MenuItem} from '../../components/SideBar'
import React from 'react';

const Menu = (
    <MenuItem title="Home" to="/" icon="home" />
)

export default Menu